<child-header [title]="title" (closeEvent)="closePage()"></child-header>
<div class="child-body my-info-wrapper">
<div class="component-wrapper" (click)="$event.stopPropagation()">
  <!-- <div class="title blade-title-font blade-title-position col-md-12">{{title}}</div> -->
  <form [formGroup]="userInfoForm" class="form-horizontal">
    <div class="div-row">
      <div class="col-md-4 form-label font-8">
        LOGIN NAME
      </div>
      <div class="col-md-12">
        <span class="flex-center lightgrey">{{currentUserModel?.loginName}}</span>
      </div>
    </div>
    <div class="div-row">
      <div class="col-md-4 form-label">
        FIRST NAME
      </div>
      <div class="col-md-12">
        <input  type="text" formControlName="firstName"/>
      </div>
      
      <div class="col-md-12 error-msg" *ngIf="isFieldValid('firstName')">
        <div class="arrow-up"></div>
        <div class="msg">Please enter your first name</div>
      </div>
    </div>
    <div class="div-row">
      <div class="col-md-4 form-label">
        LAST NAME
      </div>
      <div class="col-md-12">
        <input  type="text" formControlName="lastName" />
      </div>
      <div class="col-md-12 error-msg" *ngIf="isFieldValid('lastName')">
          <div class="arrow-up"></div>
          <div class="msg">Please enter your last name</div>
      </div>
    </div>
    <div class="div-row">
      <div class="col-md-4 form-label">
        EMAIL
      </div>
      <div class="col-md-12">
        <!-- <input  type="email" formControlName="email"/> -->
        <span class="flex-center lightgrey">{{ emailAddress }}</span>
        <button class="button button-red button-mid password-button-width-position" style="float: right;" (click)="updateEmailAndMobile('email')">Change Email</button>
      </div>
      <!-- <div style="width:100%" *ngIf="isFieldValid('email')">
        <div class="col-md-12 error-msg" *ngIf="userInfoForm.get('email').errors?.required">
            <div class="arrow-up"></div>
            <div  class="msg">Please enter your email address.</div>
        </div>
        <div class="col-md-12 error-msg" *ngIf="!userInfoForm.get('email').errors?.required && userInfoForm.get('email').errors?.email">
            <div class="arrow-up"></div>
            <div class="msg">Please enter a valid email address.</div>
        </div>
      </div> -->
    </div>
    <div class="div-row">
      <div class="col-md-12 form-label">
        MOBILE NUMBER
      </div>
      <div class="col-md-12">
         <!-- <input integerOnly type="text" id="mobileNumber" formControlName="mobileNumber" /> -->
         <span class="flex-center lightgrey">{{ mobileNumber }}</span>
         <button class="button button-red button-mid password-button-width-position" style="float: right;" (click)="updateEmailAndMobile('mobile')">Change Mobile</button>
      </div>
      <!-- <div class="col-md-12 error-msg" *ngIf="isFieldValid('mobileNumber')">
          <div class="arrow-up"></div>
          <div class="msg">Please enter your mobile number</div>
      </div> -->
    </div>
    <div class="div-row">
      <div class="col-md-12 form-label">
        PASSWORD
      </div>
      <div class="col-md-12 passwrd" [formGroup]="passwordUpdateForm">
          <!-- <input class="form-control col-md-10" type="password" formControlName="oldPassword"> -->
          <button id="change-button" style="margin-left: 230px;" class="button button-red button-mid password-button-width-position" (click)="open(changePWDContainer, $event)">Change Password</button>
        </div>
        <div class="col-md-12 offset-md-5 error-msg" *ngIf="isPasswordValid('oldPassword')">
          Please enter your old password
        </div>
    </div>
    <div class="div-row div-SMS">
      <label for="enableSMS" (click)="clickEnableSMS($event)">
        <span>MULTI-FACTOR AUTHENTICATION</span><span *ngIf="enabledMFA && sendingMethod !== ''"><br/> PREFERRED METHOD - {{ sendingMethod }}</span>
        <label class="switch">
            <input type="checkbox" id="enableSMS" [checked]="enabledMFA">
            <span class="slider round"></span>
        </label>
    </label>
    </div>
    <div class="div-row">
      <div class="col-md-12 form-label">
        ACCESS LEVEL
      </div>
      <div class="col-md-12">
        {{accessLevel}}
      </div>
    </div>
    <div class="div-row">
      <div class="col-md-12">
        <button id="btnUpdate" type="button" class="button button-red button-large" (click)="updatePersonalInfo()">Update</button>
      </div>
    </div>
  </form>
</div>
</div>
<loading-screen *ngIf="!loadContent" [showBlurTable]="false" backDropWidth="370" (currentLoadingStatus)="onLoading($event)"></loading-screen>

  
<ng-template #changePWDContainer let-c="close" let-d="dismiss" id="modal-pwd">
  <child-header title="Change your password" (click)="$event.stopPropagation()" (closeEvent)="d('Cross click')"></child-header>
  <!-- <div class="modal-header">    
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div> -->
  <div class="modal-body" (click)="$event.stopPropagation()" style="min-height:600px;">
    <form [formGroup]="passwordUpdateForm" id="popupForm">

      <div class="row" [ngClass]="displayPasswordFieldCss('oldPassword')">
        <div class="col-md-12 from-label">
          OLD PASSWORD
        </div>
        <div class="col-md-12">
          <input class="form-control" type="password" formControlName="oldPassword">
        </div>
        <div class="col-md-12 offset-md-5 error-msg" *ngIf="isPasswordValid('oldPassword')">
          Please enter your old password
        </div>
      </div>

      <div formGroupName="newPasswordGroup">
          <div class="row" [ngClass]="displayPasswordFieldCss('newPasswordGroup.newPassword')">
            <div class="col-md-12 from-label">
              NEW PASSWORD
            </div>
            <div class="col-md-12">
              <input class="form-control" type="password" formControlName="newPassword" (input)="checkPasswordStatus()">
            </div>
            <div class="col-md-12 offset-md-5 error-msg" *ngIf="isPasswordValid('newPasswordGroup.newPassword')">
              Please enter your new password
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 from-label">
              CONFIRM NEW PASSWORD
            </div>
            <div class="col-md-12">
              <input class="form-control" type="password" formControlName="confirmNewPassword">
            </div>
            <div class="col-md-12 offset-md-5 error-msg" *ngIf="passwordUpdateForm.get('newPasswordGroup').errors?.match">
              The passwords didn't match.
            </div>
            <div class="col-md-12 offset-md-5 error-msg" *ngIf="!passwordUpdateForm.get('newPasswordGroup').errors?.match && isPasswordValid('newPasswordGroup.confirmNewPassword')">
              Please confirm your password. 
            </div>
            <div class="col-md-12 offset-md-5 error-msg">
                <span [class.green-color]="passwordStatus?.lengthMatch">
                  Password should be between 8 and 20 characters in length <br>
                </span>
                <span [class.green-color]="passwordStatus?.passwordMatchThreeTypes">
                  Must contain at least 3 of the following character types <br>
                </span>
                <ul>
                  <li [class.green-color]="passwordStatus?.hasLower === 1">
                      lower case letters
                  </li>
                  <li  [class.green-color]="passwordStatus?.hasUpper === 1">
                      upper case letters
                  </li>
                  <li  [class.green-color]="passwordStatus?.hasNumbers === 1">
                      numeric digits
                  </li>
                  <li  [class.green-color]="passwordStatus?.hasSpecial === 1">
                      special characters (eq:!@#$%^&*)
                  </li>
                </ul>
            </div>
          </div>
      </div>

      <button id="btnUpdatePWD" class="button button-red col-md-12 text-initial" (click)="updatePWD()">
        Change password
      </button> 
      <button id="cancel-button" (click)="d('Cross click')">
        Cancel
      </button>
    </form>

  </div>
</ng-template>
